export var UserType = 'user';
export var ExternalUserType = 'external_user';
export var TeamType = 'team';
export var GroupType = 'group';

/*
 * Custom type created to facilitate experimentation
 * without affecting other Option types
 */

export var EmailType = 'email';
export var CustomType = 'custom';